import { TRPCLink } from '@trpc/client'
import {
	BehaviorSubject,
	Observable,
	catchError,
	filter,
	share,
	take,
	tap,
	timer,
} from 'rxjs'
import { observable } from '@trpc/server/observable'
import { AuthService } from './auth-service.js'
import { Router } from '@angular/router'
import { Injector } from '@angular/core'
import { ClientLoginResponse } from '@lg/shared'

export function createRetryRequestLink(injector: Injector) {
	const retryRequestLink: TRPCLink<any> = () => {
		const isCurrentlyRenewingTokenSubject = new BehaviorSubject(false)
		let renewLoginObservable: Observable<ClientLoginResponse> | undefined

		return ({ next, op }) => {
			return observable((observer) => {
				const retryObserver: Partial<typeof observer> = {
					next(envelope) {
						observer.next(envelope)
					},
					error(err) {
						if (err.message == 'WebSocket closed prematurely') {
							// most likely due to Angular compiler refresh, therefore ignore
							console.log(
								err.message,
								'most likely due to Angular compiler refresh or a server restart',
							)
							const retry$ = timer(5000)
							retry$.subscribe({
								next() {
									next(op).subscribe(retryObserver)
								},
								error(err) {
									observer.error(err)
								},
							})
							return
						}
						if ((err.data as any)?.code == 'UNAUTHORIZED') {
							// handle 401
							if (!renewLoginObservable) {
								const authService = injector.get(AuthService)
								authService.forceRenewLogin()
								renewLoginObservable = authService.loginRenewed$.pipe(
									take(1),
									tap({
										next: (loginResponse) => {
											console.log('renewed', loginResponse)
										},
										finalize: () => {
											// console.log('finalize')
											renewLoginObservable = undefined
										},
									}),
									share(),
								)
							}
							renewLoginObservable.subscribe({
								next(_) {
									next(op).subscribe(observer)
								},
								error(_) {
									// ignore; errors and redirect are already handled in renewLogin$
								},
								complete() {
									observer.complete()
								},
							})
						} else {
							observer.error(err)
						}
					},
				}

				const subscription = next(op).subscribe(retryObserver)
				return subscription
			})
		}
	}
	return retryRequestLink
}
